import { render, staticRenderFns } from "./entriesListCounterparty.vue?vue&type=template&id=12fa3476"
import script from "./entriesListCounterparty.vue?vue&type=script&lang=js"
export * from "./entriesListCounterparty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports